import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import RepresentanteList from './RepresentanteList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import RepresentanteCadastrar from './RepresentanteCadastrar';
import { Messages } from 'primereact/messages';
import postRepresentante from "../../service/postRepresentante";
import putRepresentante from '../../service/putRepresentante';

export default function RepresentantePage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [representante, setRepresentante] = useState<any | null>(null);
  const labelButton = t('cadastrar')

  const saveRepresentante = (representante: any) => {
    const persist = representante.id ? putRepresentante : postRepresentante;
    persist(representante).then(data => {
      if (data.includes('Erro')) {
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
            { sticky: false, life: 10000, severity: 'error', summary: 'Erro no Cadastro', detail: data.replace('Erro ao salvar Representante: ', ''), closable: false }
          ]);
        }
      }
      else {
        setRepresentante(null);
        if (msgs.current) {
          msgs.current?.clear();
          msgs.current?.show([
            { sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }
          ]);
        }
      }
    }).catch((error: any) => {
      if (msgs.current) {
        msgs.current?.clear();
        msgs.current?.show([
          { sticky: false, life: 10000, severity: 'error', summary: 'Erro no Cadastro', detail: error?.message || 'Erro inesperado ao salvar representante.', closable: false }
        ]);
      }
    })
  }

  const startContent = (
    <React.Fragment>
      <Button label={labelButton} icon="pi pi-plus" style={{ backgroundColor: '#183462' }} onClick={() => { setRepresentante({}) }} />
    </React.Fragment>
  );

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray"><i className="pi pi-address-book" style={{ fontSize: '2.0rem' }}></i> {t('representantes')}</h1>
          </div>
        </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!representante && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <RepresentanteList onEdit={(representante: any) => { setRepresentante(representante); }}></RepresentanteList>
          </>
        )}
        {representante && (
          <>
            <RepresentanteCadastrar msgs={msgs} representante={representante} onSave={saveRepresentante} onClose={() => { setRepresentante(null) }}></RepresentanteCadastrar>
          </>
        )}
      </div>

    </Container>
  )
}
